import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import React from "react";
import { Button } from "react-bootstrap";
import {
  genReport27Q_CollectorHeader,
  genReport27Q_PartyHeader,
  genReport27Q_ChallanHeader,
  getLastDateOfMonth,
} from "./client/misc";
import { getAssessmentYear } from "./admin/misc";
import moment from "moment";

const ExportToExcelGen27Q = ({
  employerData,
  challanData,
  deducteeData,
  salaryDetailData,
  fileName,
  formName,
  clientName = "",
  clientTan = "",
  financialYear,
  month = "",
  selectedQuarter,
}) => {
  const extractKeyValues = (arr, keyName) => arr.map((item) => item[keyName]);

  const filterDataByKeys = (columns, data) => {
    const allowedKeys = columns.map((col) => col.key);
    return data.map((item) => {
      const filtered = {};
      allowedKeys.forEach((key) => {
        filtered[key] = item.hasOwnProperty(key) ? item[key] : "";
      });
      return filtered;
    });
  };

  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    let fYear = financialYear.split("-");

    const sheetsConfig = [
      {
        name: "CollectorDetails",
        headerKeyArray: genReport27Q_CollectorHeader,
        data: employerData,
        sheet: "sheet1",
      },
      {
        name: "ChallanDetails",
        headerKeyArray: genReport27Q_ChallanHeader,
        data: challanData,
        sheet: "sheet2",
      },
      {
        name: "Annex-I_PartyDetails",
        headerKeyArray: genReport27Q_PartyHeader,
        data: deducteeData,
        sheet: "sheet3",
      },
    ];

    sheetsConfig.forEach(({ name, headerKeyArray, data, sheet }) => {
      const worksheet = workbook.addWorksheet(
        sheet === "sheet4" ? `${name}${fYear[0]}` : name
      );

      const headers = extractKeyValues(headerKeyArray, "label");

      if (sheet === "sheet1") {
        //SHEET 1
        const colCData = [
          "A.Y.",
          getAssessmentYear(financialYear),
          ,
          "Quarter",
          selectedQuarter,
          "Form No.",
          "27EQ",
        ];
        const filteredData = filterDataByKeys(headerKeyArray, data);
        const firstRecord = filteredData[0] || {};

        let rowIndex = 1;
        headers.forEach((header, idx) => {
          const row = worksheet.getRow(rowIndex++);
          row.getCell(1).value = header;
          row.getCell(2).value =
            firstRecord[headerKeyArray[idx].key].toUpperCase() || "";
          row.getCell(1).font = { bold: true, size: 10 };
          row.getCell(2).font = { size: 10 };
          row.getCell(1).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "CCECFF" },
          };
          row.alignment = { horizontal: "left", vertical: "middle" };
        });
        headers.forEach((header, i) => {
          worksheet.getColumn(1).width = Math.max(header.length + 5, 55);
          worksheet.getColumn(2).width = Math.max(header.length + 5, 40);
          worksheet.getColumn(3).width = Math.max(15, 3);
        });
        colCData.forEach((value, index) => {
          const cell = worksheet.getCell(`C${index + 1}`);
          cell.value = value;
          cell.alignment = { horizontal: "center", vertical: "middle" };
          cell.font = { bold: true };
        });
      } else {
        const headerRow = worksheet.getRow(1);
        headerRow.height = 70;
        headers.forEach((header, index) => {
          const cell = headerRow.getCell(index + 1);
          cell.value = header;

          cell.font = { bold: true, size: 8.5, color: { argb: "2c3e50" } };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "CCECFF" },
          };
          cell.alignment = {
            horizontal: "center",
            vertical: sheet === "sheet4" ? "top" : "middle",
            wrapText: true,
          };
          cell.border = {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          };
          worksheet.getColumn(index + 1).width = 15;
        });

        const filteredData = filterDataByKeys(headerKeyArray, data);
        let rowIndex = 2;
        let serialCounter = 0;
        let currentMonth = "";

        console.log("filteredData", filteredData);

        filteredData.forEach((item, dataIndex) => {
          const row = worksheet.getRow(rowIndex++);
          Object.values(item).forEach((value, colIndex) => {
            const cell = row.getCell(colIndex + 1);

            if (sheet === "sheet3") {
              //SHEET 3
              if (item.mn !== currentMonth) {
                serialCounter++;
                currentMonth = item.mn;
              }
              cell.value = value || "";
              if (colIndex === 0) {
                cell.value = serialCounter;
                cell.alignment = { horizontal: "center", vertical: "middle" };
              } else if (colIndex === 1) {
                cell.value = "R";
                cell.alignment = { horizontal: "center", vertical: "middle" };
              } else if (colIndex === 12) {
                cell.alignment = { horizontal: "center", vertical: "middle" };
              } else if (colIndex === 14 || colIndex === 22) {
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 23) {
                cell.value = getLastDateOfMonth(item.mn, financialYear);
                cell.alignment = { horizontal: "center", vertical: "middle" };
              } else if (colIndex === 15) {
                cell.value = moment(cell.value).format("DD-MM-YYYY");
                cell.alignment = { horizontal: "center", vertical: "middle" };
              } else if (
                colIndex === 13 ||
                colIndex === 16 ||
                colIndex === 17 ||
                colIndex === 18 ||
                colIndex === 19 ||
                colIndex === 20 ||
                colIndex === 21
              ) {
                cell.value = 0;
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (
                colIndex === 26 ||
                colIndex === 28 ||
                colIndex === 32
              ) {
                cell.value = "No";
                cell.alignment = { horizontal: "center", vertical: "middle" };
              }
            } else if (sheet === "sheet2") {
              //SHEET 2
              cell.value = value || "";
              if (colIndex === 0) {
                cell.value = dataIndex + 1;
                cell.alignment = { horizontal: "center", vertical: "middle" };
              } else if (colIndex === 1) {
                cell.value = "R";
                cell.alignment = { horizontal: "center", vertical: "middle" };
              } else if (colIndex === 8) {
                const tds = row.getCell(3).value;
                const interest = row.getCell(6).value;
                const lateFee = row.getCell(7).value;
                cell.value =
                  parseFloat(tds) + parseFloat(interest) + parseFloat(lateFee);
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (colIndex === 2 || colIndex === 5 || colIndex === 6) {
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (
                colIndex === 3 ||
                colIndex === 4 ||
                colIndex === 7 ||
                colIndex === 15 ||
                colIndex === 16
              ) {
                cell.value = 0;
                cell.value = cell.value.toFixed(2);
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else if (
                colIndex === 10 ||
                colIndex === 11 ||
                colIndex === 12
              ) {
                cell.alignment = { horizontal: "center", vertical: "middle" };
              } else if (colIndex === 13) {
                cell.value = "Yes";
                cell.alignment = { horizontal: "center", vertical: "middle" };
              }
            } else if (sheet === "sheet1") {
              cell.value = value || "";
            }

            cell.font = { size: 9.5 };
          });
        });
      }
    });
    // Save only once after all sheets are created
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `${fileName}.xlsx`);
  };

  return (
    <Button
      variant="success"
      onClick={exportToExcel}
      disabled={
        employerData.length === 0 ||
        challanData.length === 0 ||
        deducteeData.length === 0
      }
    >
      Generate Report
    </Button>
  );
};

export default ExportToExcelGen27Q;
